import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store';
import { Provider } from 'react-redux';
import './index.css';

if (process.env.NODE_ENV === 'development') {
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register('/service-worker.js')
        .then((registration) => {
            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }
            else if (registration.active) {
                sendResourceConfigData(registration.active);
            }

            navigator.serviceWorker.addEventListener('controllerchange', () => {
                if (navigator.serviceWorker.controller) {
                    sendResourceConfigData(navigator.serviceWorker.controller);
                }
            });
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });

}

function sendResourceConfigData(serviceWorker: ServiceWorker) {
    if (serviceWorker) {
        serviceWorker.postMessage({
            type: 'UPDATE_CONFIG',
            payload: JSON.parse(localStorage.getItem('resourceConfigData') || '[]')
        });
    }
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <Provider store={store}>
        <App />
    </Provider>
);

reportWebVitals();
